<template>
  <div class="app-checkbox">
    <label>
      <span class="control">
        <input
          type="checkbox"
          v-model="newValue"
          :placeholder="placeholderTrans"
          @change="onInput"
        />

        <span class="graphics" v-html="$icon('check')"></span>
      </span>
      <span class="label"><slot></slot></span>
    </label>

    <p class="message" v-if="message">{{ message }}</p>
  </div>
</template>

<script>
export default {
  props: {
    value: [Boolean],
    label: String,
    placeholder: String,
    error: Boolean,
    message: String,
  },

  data() {
    return {
      newValue: this.value,
      focused: false,
    };
  },

  watch: {
    value() {
      this.newValue = this.value;
    },
  },

  methods: {
    onInput() {
      this.$emit("input", this.newValue);
      this.$emit("change", this.newValue);
    },
  },

  computed: {
    filled() {
      return this.newValue || this.focused;
    },

    placeholderTrans() {
      return this.placeholder ? $trans(this.placeholder) : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.app-checkbox {
  position: relative;

  label {
    display: flex;
    align-items: center;
  }

  .control {
    position: relative;
    cursor: pointer;
    margin-left: 14px;

    @media screen and (max-width: $mobile) {
      margin-left: 7px;
    }

    span {
      display: block;
    }

    input {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      opacity: 0;
      z-index: 2;
      cursor: pointer;
    }

    .graphics {
      width: 23px;
      height: 23px;
      position: relative;
      z-index: 1;
      border: solid 1px $medium-dark-gray;
      background-color: $white;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1px;

      @media screen and (max-width: $mobile) {
        width: 19px;
        height: 19px;
      }

      ::v-deep svg {
        display: block;
        opacity: 0;
        flex-grow: 1;
      }
    }

    input:checked + .graphics {
      background-color: $primary-blue;

      ::v-deep svg {
        opacity: 1;
      }
    }
  }

  .label {
    font-size: 20px;
    font-weight: $font-light;
    letter-spacing: 0.8px;
    color: $black;

    @media screen and (max-width: $mobile) {
      font-size: 18px;
    }
  }

  .message {
    font-size: 1em;
    margin: 10px 0 0;
    color: $error-red;
    font-weight: $font-normal;
  }
}
</style>
